<template lang="pug">
ClientOnly
    .group.h-dvh(
        v-if="coreStore.mainSidebarValue !== 0"
        id="zSidebar"
        :class="{\
            'rsidebar': coreStore.mainSidebarValue === 1, \
            'rsidebar-md': coreStore.mainSidebarValue === 2\
        }"
    )
        .flex.h-dvh.max-h-dvh.flex-grow.flex-col.text-neutral-300.sdbrx(
            class="transition duration-1000 ease-in-out transform-gpu slide-in-from-left"
            :class="{'bg-zinc-900': $route.name.includes('admin')}"
        )
            .flex.flex-1.flex-col
                .w-full.border-b(class="h-12 max-h-12")
                    .flex.self-center.flex-1(
                        class="h-12 max-h-12"
                        :class="{'justify-center': coreStore.mainSidebarValue === 1}"
                    )

                        //- ++++++++++++++++++++++++++++++++++
                        //- Custom Logo Here
                        //- ++++++++++++++++++++++++++++++++++
                        .flex.flex-1.flex-col.items-center(
                            v-if="coreStore.mainSidebarValue === 1"
                        )
                            NuxtLink(to="/")
                                DefaultLogo(sm)
                        .flex.flex-1.flex-col(
                            v-else
                        )
                            .flex.flex-1.items-center.justify-start
                                DefaultLogo

                //- +++++++++++++++++++++
                .flex.flex-1.h-full(:class="{'py-2': coreStore.mainSidebarValue === 1}")
                    DefaultSidebar

                .flex.flex-col.px-2(
                    :class="{'justify-center': coreStore.mainSidebarValue === 1}"
                )
                    //- .flex(
                    //-     :class="{'justify-center': coreStore.mainSidebarValue === 1}"
                    //- )
                    //-     UButton.font-normal(
                    //-         to="/"
                    //-         color="neutral"
                    //-         :label="coreStore.mainSidebarValue ? 'Administrator' : ''"
                    //-         size="md" variant="ghost" icon="heroicons:shield-check"
                    //-     )

                    ClientOnly
                        .flex.flex-1.py-2(
                            :class="{'justify-center': coreStore.mainSidebarValue === 1}"
                        )
                            UButton.text-neutral-400.text-xs.font-normal(
                                size="md"
                                variant="link"
                                color="neutral"
                                :label="coreStore.mainSidebarValue === 2 ? 'Collapse sidebar' : ''"
                                icon="heroicons:chevron-double-left-20-solid"
                                @click="coreStore.mainSidebar = coreStore.mainSidebar === 1 ? 0 : 1"
                            )

</template>
<script setup lang="ts">
import { DefaultSidebar } from "#components";
const coreStore = useTemplateStore();
const router = useRouter();

router.beforeEach((to, from, next) => {
  coreStore.sidebarMob = false;
  next();
});
</script>
